import Swiper from 'swiper'

export default class ScrollNav {
  constructor(el) {
    this.el = el
    this.$el = $(this.el)

    new Swiper(this.el, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
    })
  }
}
